import { TokenService } from './token.service';

export class LoginManager {
  public readonly tokenService: TokenService;

  constructor() {
    const tokenService = new TokenService();
    this.tokenService = tokenService;
  }

  // ====================================================
  // Token Service
  // ====================================================

  public accessTokenObservable: TokenService['accessTokenObservable'] = () => {
    return this.tokenService.accessTokenObservable();
  };

  public authenticate: TokenService['authenticate'] = () => {
    return this.tokenService.authenticate();
  };

  public getToken: TokenService['getToken'] = () => {
    return this.tokenService.getToken();
  };

  public getTokenAsync: TokenService['getTokenAsync'] = () => {
    return this.tokenService.getTokenAsync();
  };

  public setToken: TokenService['setToken'] = (token, clientId, refreshToken, serverTime) => {
    return this.tokenService.setToken(token, clientId, refreshToken, serverTime);
  };

  public clearToken = () => {
    return this.tokenService.deleteSecrets();
  };

  // ====================================================
  // Auth Service
  // ====================================================
  // We will add this section back when we want to handle login via marcom.
}
